import actions from './actions'

const sites = (state = { list: [], searched: false }, action) => {
  switch (action.type) {
    case actions.setSites:
      return { list: action.sites, searched: true }
    case actions.fetchPending:
      return { loading: true, list: [] }
    case actions.resetSites:
      return { list: [], searched: false }
    default:
      return state
  }
}

export default sites



// WEBPACK FOOTER //
// ./src/store/sites/reducer.js